import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  const painPoints = [{
    icon: '🧠',
    quote: 'You had a brilliant idea at 2am. By morning, it was gone.',
    desc: "Your mind never stops — but your systems can't keep up. Great ideas disappear before they become action."
  }, {
    icon: '📢',
    quote: 'You told your team something important. Three weeks later, nothing happened.',
    desc: "You've said it once, twice, three times. The follow-up falls on you. Again. Always you."
  }, {
    icon: '⏰',
    quote: "You're working 60-hour weeks. The business still can't run without you.",
    desc: 'You built something great — but you became the bottleneck.'
  }];
  return <section className="section-padding bg-white relative overflow-hidden" data-id="element-835">
      {/* Subtle Ambient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple/5 rounded-full blur-[150px] opacity-40 pointer-events-none" data-id="element-836" />

      <div className="inner-container relative z-10" data-id="element-837">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-838">
          <span className="text-purple text-sm font-poppins font-bold uppercase tracking-widest" data-id="element-839">
            The Problem
          </span>
          <h2 className="font-poppins font-extrabold text-4xl md:text-5xl leading-tight mt-4 text-gray-900" data-id="element-840">
            Does This Sound Like You?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-841">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm hover:border-purple/40 hover:shadow-lg hover:shadow-purple/5 transition-all duration-300" data-id="element-842">
              <div className="text-4xl mb-6" data-id="element-843">{point.icon}</div>
              <h3 className="font-poppins font-semibold text-xl mb-4 leading-snug text-gray-900" data-id="element-844">
                "{point.quote}"
              </h3>
              <p className="text-gray-500 leading-relaxed" data-id="element-845">{point.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center max-w-2xl mx-auto p-6 rounded-xl bg-gray-50 border border-gray-200 relative overflow-hidden group" data-id="element-846">
          <div className="absolute inset-0 bg-gradient-to-r from-purple/10 via-teal/10 to-purple/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-847" />
          <p className="text-lg md:text-xl font-medium relative z-10 text-gray-800" data-id="element-848">
            That's not a discipline problem. That's a systems problem.{' '}
            <span className="text-purple font-bold" data-id="element-849">
              MIndSTReam.ing fixes it.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}